import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.site-preferences')
  .factory('$travelTimeRule', travelTimeRuleObjectFactory);

/* @ngInject */
function travelTimeRuleObjectFactory($bringozFactory: $bringozFactory,
                                     TravelTimeRuleAPI: BringozApi) {

  function $travelTimeRule(id: string) {
    return $bringozFactory(id, TravelTimeRuleAPI)
  }

  return $travelTimeRule
}
